import { Navigate } from "react-router-dom";
import { useAdminAuth } from "../context/AuthContext";

const PrivateRoute = ({ children }) => {

  const { isLoggedIn, loading } = useAdminAuth();
  
  if (loading) return <div>Loading...</div>;
  
  return isLoggedIn ? children : <Navigate to="/admin/login" />;
  
};

export default PrivateRoute;
